module.exports = __webpack_public_path__ + "static/media/avatar_3.5858e1f6.png";